import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllRoles = async () => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/roles`);
  const result = await response.json();
  return result;
};

export default fetchAllRoles;
